import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('./../../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/InstarVision_Erklärung_der_Einstellungen_in_iPhone_App_InstarVision.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>Wir erklären Ihnen in diesem Video wie Sie manuell auf die Speicherkarte bzw. den internen Speicher Ihres iPhones aufnehmen können. Zudem wird gezeigt wie Sie auf die SD Speicherkarte einer INSTAR HD Kamera zugreifen können über die kostenfreie App InstarVision. Auf <OutboundLink href="https://www.youtube.com/watch?v=P-YyavzBkEk" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)